import { type TSearchQueryParams } from '@core/api'

export type TSearchType = TSearchQueryParams['types']
export type TSearchSort = NonNullable<TSearchQueryParams['sort']>

export const ALL_TYPES: TSearchType = 'audio,author,collection'

type TFilterOption = {
    value: string
    labelKey: `i18n.${string}`
}

export const SEARCH_TYPE_OPTIONS = [
    { value: ALL_TYPES, labelKey: 'i18n.searchTypeAll' },
    { value: 'audio', labelKey: 'i18n.searchTypeAudio' },
    { value: 'author', labelKey: 'i18n.searchTypeAuthor' },
    { value: 'collection', labelKey: 'i18n.searchTypeCollection' },
] as const satisfies readonly TFilterOption[]

// The nextjs order (`Relevance / Most downloads / Most popular / Most recent`) — the dropdown is
// part of the document a crawler reads, so the sequence is a parity fact, not a preference.
export const SEARCH_SORT_OPTIONS = [
    { value: 'relevance', labelKey: 'i18n.searchSortRelevance' },
    { value: 'downloads_desc', labelKey: 'i18n.searchSortDownloads' },
    { value: 'plays_desc', labelKey: 'i18n.searchSortPopular' },
    { value: 'date_desc', labelKey: 'i18n.searchSortRecent' },
] as const satisfies readonly TFilterOption[]
